import React from 'react'
import {
    Avatar,
    Box,
    Card,
    CardActions,
    CardContent,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Typography
} from "@mui/material"

import FavoriteIcon from '@mui/icons-material/Favorite'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'

import SearchBar from "./SearchBar"
import {hideLoading} from "../Utils"

import Song from "../interfaces/Song"
import Session from "../interfaces/Session"


type SongListProps = {
    session: Session
    songs: Song[]
    onVote: (songKey: string) => void
}

const SongList = (props: SongListProps) => {
    const {session, songs, onVote} = props

    const [search, setSearch] = React.useState<string>('')

    React.useEffect(() => {
        hideLoading()
    }, [])

    const onFavoriteClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        onVote(e.currentTarget.getAttribute('data-key') || '')
    }

    const onSearchChange = (value: string): void => {
        setSearch(value)
    }

    const onAvatarClick = () => {
        window.open("https://www.axelchill.com");
    }

    const songList = React.useMemo<Song[]>(() => {

        return (search !== '' ? songs.filter(song => (song.artist.toLowerCase().includes(search.toLowerCase()) || song.title.toLowerCase().includes(search.toLowerCase()))) : songs)
            .sort(Song.sortByPosition)

    }, [songs, search])

    return <Box>
        <Card sx={{
            position: "sticky",
            zIndex  : 1,
            top     : 0
        }}>
            <CardContent sx={{display: "flex"}}>
                <Box sx={{flexGrow: 1}}>
                    <Typography variant="h5" component="div">{session.title}</Typography>
                    <Typography sx={{mb: 1.5}} color="text.secondary">{session.description}</Typography>
                </Box>
                <Avatar
                    alt="Axel CHILL"
                    src="/axelchill.jpg"
                    onClick={onAvatarClick}
                    sx={{width: 92, height: 92}}
                />
            </CardContent>
            <CardActions>
                <SearchBar value={search} onChange={onSearchChange}/>
            </CardActions>
        </Card>
        <List>
            {
                songList.length > 0 ?
                    songList.map((song) =>
                        <ListItem key={song.key} style={song.sessionPlayed ? {opacity: 0.5} : {}}
                                  secondaryAction={<IconButton onClick={onFavoriteClick} edge="end" data-key={song.key}
                                                               disabled={song.sessionPlayed}>{song.sessionVoted ?
                                      <FavoriteIcon color={"primary"}/> : <FavoriteBorderIcon/>}</IconButton>}>
                            <ListItemText primary={<>{song.position ? <span style={{fontSize: '0.875rem'}}>{song.position} - </span> : ''} {song.title} {song.sessionPlayed ? <span style={{
                                fontSize: "0.7rem",
                                opacity: 0.6,
                                fontStyle: "italic"
                            }}>- déjà joué</span> : null}</>} secondary={song.artist}/>
                        </ListItem>
                    )
                    :
                    <>
                        <Typography sx={{opacity: 0.5}} textAlign="center">chargement des titres</Typography>
                    </>
            }
        </List>
    </Box>
}

export default SongList
